// extracted by mini-css-extract-plugin
export var bigHoverActionButton = "EjecV";
export var bigHoverActionContainer = "wBMYh";
export var sclBigHoverActionButton = "YxiXc";